var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-footer', {
    style: 'background-color:' + _vm.color,
    attrs: {
      "padless": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_vm.$route.meta.btnHelp ? _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-lg ml-btn-help",
    attrs: {
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v(" Precisa de ajuda? ")])], 1) : _vm._e(), _vm.$route.meta.ambienteSeguro ? _c('v-col', {
    staticClass: "d-flex justify-center align-end",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1 ml-text-color",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-lock-outline")]), _c('p', {
    staticClass: "ml-font-14 mb-0 ml-text-security ml-text-color"
  }, [_vm._v(" Você está em um ambiente seguro. ")])], 1) : _vm._e(), _c('v-col', {
    staticClass: "py-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "ml-divider"
  })]), _c('v-col', {
    staticClass: "d-flex align-center",
    "class": !_vm.$vuetify.breakpoint.xs ? 'pa-5' : '',
    attrs: {
      "cols": "12"
    }
  }, [!_vm.$vuetify.breakpoint.xs ? _c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": require("@/assets/img/logo_me_lembre.png"),
      "alt": "Logo do MeLembre",
      "height": "31"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "ml-text-footer ml-font-14 ml-text-color",
    "class": {
      'text-center': _vm.$vuetify.breakpoint.xs
    }
  }, [_vm._v(" O MeLembre é um serviço de comunicação entre empresas e pessoas. Simplificamos e aprimoramos o relacionamento com seu público. "), _c('a', {
    staticClass: "font-weight-bold link-saiba-mais",
    attrs: {
      "target": "_blank",
      "href": "https://melembre.com.br/?utm_source=autosservico&utm_content=rodape",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Saiba mais aqui.")])])]), _vm.$vuetify.breakpoint.xs ? _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/logo_me_lembre.png"),
      "alt": "Logo do MeLembre",
      "height": "31"
    }
  })]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };